import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Link as WouterLink } from "wouter";
import { ROUTE } from "../../../common/ROUTE";
import { SITE_STRINGS } from "../../constants";
import { resolveCdnAssetUrl } from "../../utils/cdnAssetUrl";

export function HeaderLogo() {
  const logoUrl = resolveCdnAssetUrl("logo.svg");

  return (
    <WouterLink
      style={{ display: "flex", alignItems: "center", gap: "8px" }}
      href={ROUTE.HOME}
    >
      <Box
        component="img"
        src={logoUrl}
        alt={SITE_STRINGS.HEADER_LOGO_ALT}
        sx={{
          height: { sm: "48px", lg: "72px" },
          cursor: "pointer",
        }}
      />
      <Box sx={{ display: { sm: "none", md: "block" } }}>
        <Typography
          sx={{
            color: "#FFF",
            fontSize: { sm: "16px", lg: "24px" },
            fontWeight: 700,
          }}
        >
          mydecisive.ai
        </Typography>
      </Box>
    </WouterLink>
  );
}
